(() => {
  const roots = document.querySelectorAll('[data-gifty-customizer]');
  if (!roots.length) return;

  const uid = () => `GFT-${new Date().toISOString().slice(0, 10).replaceAll('-', '')}-${crypto.getRandomValues(new Uint32Array(1))[0].toString(36).slice(0, 6).toUpperCase()}`;
  const clone = (value) => JSON.parse(JSON.stringify(value));
  const artworkDataType = (data) => {
    if (typeof data !== 'string' || data.length > 2.1 * 1024 * 1024) return null;
    const match = /^data:(image\/(?:png|jpeg|svg\+xml));base64,([A-Za-z0-9+/=\s]+)$/.exec(data);
    if (!match) return null;
    try {
      const bytes = atob(match[2]);
      if (bytes.length > 1.5 * 1024 * 1024) return null;
      if (match[1] === 'image/svg+xml') {
        if (!/<svg\b/i.test(bytes) || /<!DOCTYPE|<!ENTITY|<script|<foreignObject|<iframe|<object|<embed|<style|\son\w+\s*=|(?:href|src)\s*=\s*["'](?!#)|url\s*\(|@import/i.test(bytes)) return null;
      }
      return match[1];
    } catch (_) { return null; }
  };
  const artworkGeometry = (width, height, area, preferredWidth) => {
    if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0 || width * height > 40000000) return null;
    const aspect = width / height;
    return { aspect, size: Math.min(preferredWidth, area.width * .78, area.height * aspect * .78) };
  };
  const reorderLayer = (objects, selectedId, direction) => {
    const index = objects.findIndex((item) => item.id === selectedId);
    if (index < 0 || ![-1, 1].includes(direction)) return false;
    const target = Math.max(0, Math.min(objects.length - 1, index + direction));
    if (target === index) return false;
    const [item] = objects.splice(index, 1);
    objects.splice(target, 0, item);
    return true;
  };
  const pushEvent = (event, detail = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...detail });
  };

  roots.forEach((root) => {
    const $ = (selector) => root.querySelector(selector);
    const $$ = (selector) => [...root.querySelectorAll(selector)];
    const config = JSON.parse($('[data-gxc-config]').textContent);
    const urlParams = new URLSearchParams(window.location.search);
    let transferredBrief = '';
    let transferredQuantity = 0;
    try {
      const brief = JSON.parse(sessionStorage.getItem('gifty-design-brief') || 'null');
      const age = Date.now() - Number(brief?.savedAt || 0);
      if (brief && age >= 0 && age < 30 * 60 * 1000 && brief.pathname === new URL(config.productUrl, window.location.origin).pathname) {
        transferredBrief = String(brief.text || '').slice(0, 1600);
        if (Number.isSafeInteger(brief.quantity) && brief.quantity > 0) transferredQuantity = brief.quantity;
        sessionStorage.removeItem('gifty-design-brief');
      } else if (brief && (age < 0 || age >= 30 * 60 * 1000)) sessionStorage.removeItem('gifty-design-brief');
    } catch (_) {}
    const storageKey = `gifty-design:${config.productHandle}`;
    const backdrop = $('[data-gxc-backdrop]');
    const dialog = $('.gxc__dialog');
    const stage = $('[data-gxc-stage]');
    const productImage = $('[data-gxc-product-image]') || $('.gxc__product-image');
    const objectsLayer = $('[data-gxc-objects]');
    const safeAreaEl = $('[data-gxc-safe-area]');
    const areaLabel = $('[data-gxc-area-label]');
    const status = $('[data-gxc-status]');
    const quality = $('[data-gxc-quality]');
    const designLabel = $('[data-gxc-design-id]');
    const saveButton = $('[data-gxc-save]');
    const quoteButton = $('[data-gxc-quote]');
    const cartButton = $('[data-gxc-cart]');
    const upload = $('[data-gxc-upload]');
    const textInput = $('[data-gxc-text-input]');
    const sizeControl = $('[data-gxc-size]');
    const rotateControl = $('[data-gxc-rotate]');
    const opacityControl = $('[data-gxc-opacity]');
    const filterControl = $('[data-gxc-filter]');
    const quantityControl = $('[data-gxc-quantity]');
    if (transferredQuantity) quantityControl.value = String(transferredQuantity);
    const methodControl = $('[data-gxc-method]');
    const undoButton = $('[data-gxc-undo]');
    const redoButton = $('[data-gxc-redo]');
    const duplicateButton = $('[data-gxc-duplicate]');
    const deleteButton = $('[data-gxc-delete]');
    const centerButton = $('[data-gxc-center]');
    const fitButton = $('[data-gxc-fit]');
    const smartArrangeButton = $('[data-gxc-smart-arrange]');
    const artworkCheckButton = $('[data-gxc-artwork-check]');
    const resetButton = $('[data-gxc-reset]');
    const shareButton = $('[data-gxc-share]');
    const zoomControl = $('[data-gxc-zoom]');
    const fullscreenButton = $('[data-gxc-fullscreen]');
    const textControls = $('[data-gxc-text-controls]');
    const editTextControl = $('[data-gxc-edit-text]');
    const layerForwardButton = $('[data-gxc-layer-forward]');
    const layerBackwardButton = $('[data-gxc-layer-backward]');
    const fontControl = $('[data-gxc-font]');
    const colorControl = $('[data-gxc-color]');
    const letterSpacingControl = $('[data-gxc-letter-spacing]');
    const boldButton = $('[data-gxc-bold]');
    const italicButton = $('[data-gxc-italic]');
    const alignButtons = $$('[data-gxc-align]');
    const viewButtons = $$('[data-gxc-view]');
    const serviceModeButtons = $$('[data-gxc-service-mode]');
    const assistedNote = $('[data-gxc-assisted-note]');
    const commentsControl = $('[data-gxc-comments]');
    const proofControl = $('[data-gxc-proof]');

    let parsedAreas = config.printableAreas;
    if (typeof parsedAreas === 'string') {
      try { parsedAreas = JSON.parse(parsedAreas); } catch (_) { parsedAreas = null; }
    }
    const firstConfiguredArea = Array.isArray(parsedAreas) ? parsedAreas[0] : (parsedAreas?.areas?.[0] || parsedAreas?.front || null);
    const area = {
      x: Number(firstConfiguredArea?.x ?? 30),
      y: Number(firstConfiguredArea?.y ?? 27),
      width: Number(firstConfiguredArea?.width ?? firstConfiguredArea?.w ?? 40),
      height: Number(firstConfiguredArea?.height ?? firstConfiguredArea?.h ?? 46)
    };
    safeAreaEl.style.left = `${area.x}%`;
    safeAreaEl.style.top = `${area.y}%`;
    safeAreaEl.style.width = `${area.width}%`;
    safeAreaEl.style.height = `${area.height}%`;
    areaLabel.textContent = config.mode === 'configured' ? (firstConfiguredArea?.label || 'Configured print area') : 'Preview workspace · review required';

    const artworkData = new Map();
    const stateForHistory = (source) => {
      const copy = clone(source);
      copy.objects.forEach((item) => {
        if (item.type === 'image' && item.data) artworkData.set(item.id, item.data);
        if (item.type === 'image') delete item.data;
      });
      return copy;
    };
    const hydrateState = (source) => {
      const copy = clone(source);
      copy.objects.forEach((item) => {
        if (item.type === 'image' && !item.data) item.data = artworkData.get(item.id) || '';
      });
      return copy;
    };
    const stateForStorage = () => {
      const copy = stateForHistory(state);
      const assets = {};
      const references = new Map();
      copy.objects.forEach((item) => {
        if (item.type !== 'image') return;
        const data = artworkData.get(item.id) || state.objects.find((candidate) => candidate.id === item.id)?.data || '';
        if (!data) return;
        let reference = references.get(data);
        if (!reference) { reference = `asset-${Object.keys(assets).length + 1}`; references.set(data, reference); assets[reference] = data; }
        item.assetRef = reference;
      });
      return { ...copy, assets };
    };
    const stateFromStorage = (saved) => {
      const copy = clone(saved);
      const assets = copy.assets || {};
      delete copy.assets;
      copy.objects = copy.objects || [];
      // Remove known internal QA artifacts left by prior storefront testing.
      // Customer-created logos and text remain intact.
      const internalQaNames = new Set(['test-artwork.svg', 'gifty-low-res-test.png', 'wide-logo.svg']);
      copy.objects = copy.objects.filter((item) => {
        const label = String(item.name || item.text || '').trim();
        const isInternalReleaseLabel = item.type === 'text' && /^Gifty\s+(?:Mark\s+\d+(?:\.\d+)?|QA)$/i.test(label);
        const isInternalArtwork = item.type === 'image' && internalQaNames.has(label.toLowerCase());
        return !isInternalReleaseLabel && !isInternalArtwork;
      });
      if (!copy.objects.length) {
        copy.selectedId = '';
        copy.artworkName = '';
        copy.artworkQuality = 'No artwork uploaded';
        copy.designId = '';
      } else if (copy.selectedId && !copy.objects.some((item) => item.id === copy.selectedId)) {
        copy.selectedId = copy.objects.at(-1)?.id || '';
      }
      copy.objects.forEach((item) => {
        if (item.type !== 'image') return;
        item.data = item.data || assets[item.assetRef] || '';
        if (item.data) artworkData.set(item.id, item.data);
      });
      return copy;
    };
    let state = { designId: '', selectedId: '', artworkName: '', artworkQuality: 'No artwork uploaded', giftBrief: transferredBrief, serviceMode: 'self', objects: [] };
    let history = [stateForHistory(state)];
    let historyIndex = 0;
    let lastFocus = null;
    let cancelActiveDrag = null;

    const selected = () => state.objects.find((item) => item.id === state.selectedId);
    const setStatus = (message, isError = false) => {
      status.textContent = message;
      status.classList.toggle('is-error', isError);
    };
    const makeId = (prefix) => `${prefix}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 6)}`;
    const ensureDesignId = () => {
      if (!state.designId) state.designId = uid();
      designLabel.textContent = `Design ID: ${state.designId}`;
    };
    const snapshot = () => {
      history = history.slice(0, historyIndex + 1);
      history.push(stateForHistory(state));
      if (history.length > 40) history.shift();
      historyIndex = history.length - 1;
      updateButtons();
      autoSave();
    };
    const restore = (next) => {
      state = hydrateState(next);
      render();
      updateButtons();
      autoSave();
    };
    const elementFilter = (mode) => ({
      mono: 'grayscale(1) contrast(1.12)',
      black: 'grayscale(1) brightness(0)',
      white: 'grayscale(1) brightness(0) invert(1) drop-shadow(0 1px 1px rgba(0,0,0,.25))'
    }[mode] || 'none');
    const isOutside = (item) => {
      const element = objectsLayer.querySelector(`[data-gxc-object="${CSS.escape(item.id)}"]`);
      if (element && safeAreaEl.isConnected) {
        const elementRect = element.getBoundingClientRect();
        const areaRect = safeAreaEl.getBoundingClientRect();
        if (elementRect.width && areaRect.width) {
          const tolerance = 1;
          return elementRect.left < areaRect.left - tolerance || elementRect.right > areaRect.right + tolerance || elementRect.top < areaRect.top - tolerance || elementRect.bottom > areaRect.bottom + tolerance;
        }
      }
      const halfWidth = item.type === 'image' ? Number(item.size || 0) / 2 : Math.min(area.width / 2, Math.max(5, String(item.text || '').length * .7));
      const halfHeight = item.type === 'image' ? (Number(item.size || 0) / Math.max(.0001, Number(item.aspect || 1))) / 2 : Math.max(3, Number(item.size || 0) * .08);
      return item.x - halfWidth < area.x || item.x + halfWidth > area.x + area.width || item.y - halfHeight < area.y || item.y + halfHeight > area.y + area.height;
    };

    const render = () => {
      objectsLayer.innerHTML = '';
      state.objects.forEach((item) => {
        const el = document.createElement('div');
        el.className = `gxc__object gxc__object--${item.type}`;
        el.dataset.gxcObject = item.id;
        el.style.left = `${item.x}%`;
        el.style.top = `${item.y}%`;
        el.style.width = item.type === 'image' ? `${item.size}%` : 'auto';
        el.style.opacity = String(item.opacity / 100);
        el.style.transform = `translate(-50%,-50%) rotate(${item.rotation}deg)`;
        el.tabIndex = 0;
        el.setAttribute('role', 'button');
        el.setAttribute('aria-label', `${item.type === 'image' ? 'Artwork' : 'Text'} ${item.name || item.text || ''}. Drag or use arrow keys to move.`);
        el.classList.toggle('is-selected', item.id === state.selectedId);
        if (item.type === 'image') {
          const image = document.createElement('img');
          image.src = item.data;
          image.alt = item.name || 'Uploaded artwork';
          image.draggable = false;
          image.style.filter = elementFilter(item.filter);
          el.append(image);
        } else {
          el.textContent = item.text;
          const stageWidth = stage.clientWidth || 620;
          el.style.setProperty('--gxc-text-size', `${Math.max(14, stageWidth * (item.size / 100) * .12)}px`);
          el.style.filter = elementFilter(item.filter);
          el.style.fontFamily = item.fontFamily || 'Arial, sans-serif';
          el.style.color = item.color || '#0d243b';
          el.style.fontWeight = item.bold === false ? '500' : '800';
          el.style.fontStyle = item.italic ? 'italic' : 'normal';
          el.style.textAlign = item.align || 'center';
          el.style.letterSpacing = `${Number(item.letterSpacing || 0)}px`;
        }
        objectsLayer.append(el);
      });
      state.objects.forEach((item) => objectsLayer.querySelector(`[data-gxc-object="${CSS.escape(item.id)}"]`)?.classList.toggle('is-outside', isOutside(item)));
      quality.textContent = state.artworkQuality;
      if (state.designId) designLabel.textContent = `Design ID: ${state.designId}`;
      syncControls();
      validate();
    };

    const validate = () => {
      const hasDesign = state.objects.length > 0;
      const outside = state.objects.some(isOutside);
      const emptyText = state.objects.some((item) => item.type === 'text' && !String(item.text || '').trim());
      const productionConfigured = config.mode === 'configured';
      const assisted = state.serviceMode === 'assisted';
      quoteButton.disabled = (!hasDesign && !assisted) || emptyText;
      shareButton.disabled = !hasDesign || emptyText;
      cartButton.disabled = !hasDesign || emptyText || outside || !productionConfigured;
      if (emptyText) setStatus(config.emptyText, true);
      else if (outside) setStatus('Move the highlighted element into the active preview area before adding to cart. You can still request a manual quote.', true);
      else if (hasDesign) setStatus(productionConfigured ? 'Design is inside the configured area. Artwork approval is still required.' : 'Preview ready. Request an exact quote so Gifty can confirm print area, method, MOQ and production timing.');
      else if (assisted) setStatus('Gifty design help selected. Add your project details, then send the brief for an exact quote and a human-reviewed proof.');
      else setStatus('Ready to start your design.');
    };

    const updateButtons = () => {
      const hasSelected = !!selected();
      undoButton.disabled = historyIndex <= 0;
      redoButton.disabled = historyIndex >= history.length - 1;
      [duplicateButton, deleteButton, centerButton, fitButton, smartArrangeButton].forEach((button) => { if (button) button.disabled = !hasSelected; });
      const layerIndex = state.objects.findIndex((item) => item.id === state.selectedId);
      if (layerBackwardButton) layerBackwardButton.disabled = layerIndex <= 0;
      if (layerForwardButton) layerForwardButton.disabled = layerIndex < 0 || layerIndex === state.objects.length - 1;
    };
    const syncControls = () => {
      const item = selected();
      if (item) {
        sizeControl.min = item.type === 'image' ? '.1' : '10';
        sizeControl.value = item.size;
        rotateControl.value = item.rotation;
        opacityControl.value = item.opacity;
        filterControl.value = item.filter;
        textControls.hidden = item.type !== 'text';
        if (item.type === 'text') {
          if (editTextControl && editTextControl.value !== item.text) editTextControl.value = item.text;
          fontControl.value = item.fontFamily || 'Arial, sans-serif';
          colorControl.value = item.color || '#0d243b';
          letterSpacingControl.value = Number(item.letterSpacing || 0);
          boldButton.setAttribute('aria-pressed', String(item.bold !== false));
          italicButton.setAttribute('aria-pressed', String(!!item.italic));
          alignButtons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.gxcAlign === (item.align || 'center'))));
        }
      } else {
        textControls.hidden = true;
      }
      updateButtons();
    };
    const autoSave = () => {
      if (!state.designId) return;
      try {
        const payload = JSON.stringify({ ...stateForStorage(), savedAt: new Date().toISOString() });
        if (payload.length < 3_500_000) localStorage.setItem(storageKey, payload);
      } catch (_) { /* Storage can be unavailable; explicit Save reports this. */ }
    };

    const open = () => {
      lastFocus = document.activeElement;
      backdrop.hidden = false;
      backdrop.scrollTop = 0;
      document.documentElement.classList.add('gxc__lock');
      dialog.focus();
      pushEvent('customizer_open', { item_name: config.productTitle, customizer_mode: config.mode });
    };
    const close = () => {
      cancelActiveDrag?.();
      backdrop.hidden = true;
      document.documentElement.classList.remove('gxc__lock');
      lastFocus?.focus?.();
    };

    $('[data-gxc-open]').addEventListener('click', open);
    document.querySelectorAll('[data-gxc-open-global]').forEach((button) => button.addEventListener('click', () => {
      if (button.dataset.gxcTarget && button.dataset.gxcTarget !== String(config.productId)) return;
      open();
    }));
    document.querySelectorAll('[data-gxc-media-open]').forEach((button) => button.addEventListener('click', open));
    $('[data-gxc-close]').addEventListener('click', close);
    backdrop.addEventListener('click', (event) => { if (event.target === backdrop) close(); });
    document.addEventListener('keydown', (event) => {
      if (backdrop.hidden) return;
      if (event.key === 'Escape') { close(); return; }
      if (event.key !== 'Tab') return;
      const focusable = [...dialog.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter((item) => !item.hidden && item.getClientRects().length);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable.at(-1);
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });

    const activateStep = (button) => {
      if (!button) return;
      const step = button.getAttribute('data-gxc-step-button');
      backdrop.querySelectorAll('[data-gxc-step-button]').forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      backdrop.querySelectorAll('[data-gxc-panel]').forEach((panel) => {
        const active = panel.getAttribute('data-gxc-panel') === step;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    };
    backdrop.addEventListener('click', (event) => {
      const button = event.target.closest('[data-gxc-step-button]');
      if (!button || !backdrop.contains(button)) return;
      activateStep(button);
    }, true);
    backdrop.querySelector('.gxc__steps')?.addEventListener('keydown', (event) => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      const tabs = [...backdrop.querySelectorAll('[data-gxc-step-button]')];
      const current = Math.max(0, tabs.indexOf(document.activeElement));
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (current + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
      event.preventDefault();
      tabs[next].focus();
      activateStep(tabs[next]);
    });
    serviceModeButtons.forEach((button) => button.addEventListener('click', () => {
      const nextMode = button.dataset.gxcServiceMode === 'assisted' ? 'assisted' : 'self';
      state.serviceMode = nextMode;
      serviceModeButtons.forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      if (assistedNote) assistedNote.hidden = nextMode !== 'assisted';
      if (nextMode === 'assisted') activateStep(backdrop.querySelector('[data-gxc-step-button="order"]'));
      validate();
      autoSave();
      pushEvent('customizer_service_mode', { item_name: config.productTitle, service_mode: nextMode });
    }));

    const activateView = (button) => {
      if (!button || !productImage || !button.dataset.gxcView) return;
      // The initial responsive candidates belong to the first image only.
      productImage.removeAttribute('srcset');
      productImage.removeAttribute('sizes');
      productImage.src = button.dataset.gxcView;
      productImage.alt = button.dataset.gxcViewAlt || config.productTitle;
      viewButtons.forEach((item) => item.classList.toggle('is-active', item === button));
      setStatus(config.imageChanged || 'Image changed. Placement remains an approximate mockup until artwork approval.');
    };
    viewButtons.forEach((button) => button.addEventListener('click', () => activateView(button)));

    let angleDrag = null;
    stage.addEventListener('pointerdown', (event) => {
      if (event.isPrimary === false || event.button !== 0 || event.target.closest('[data-gxc-object]') || viewButtons.length < 2) return;
      angleDrag = { x: event.clientX, pointerId: event.pointerId, active: true };
    });
    stage.addEventListener('pointerup', (event) => {
      if (!angleDrag?.active || event.pointerId !== angleDrag.pointerId) return;
      const delta = event.clientX - angleDrag.x;
      angleDrag = null;
      if (Math.abs(delta) < 38) return;
      const current = Math.max(0, viewButtons.findIndex((button) => button.classList.contains('is-active')));
      const next = (current + (delta < 0 ? 1 : -1) + viewButtons.length) % viewButtons.length;
      activateView(viewButtons[next]);
    });
    stage.addEventListener('pointercancel', () => { angleDrag = null; });
    stage.addEventListener('pointerleave', () => { angleDrag = null; });

    upload.addEventListener('change', () => {
      const file = upload.files?.[0];
      if (!file) return;
      const allowed = ['image/png', 'image/jpeg', 'image/svg+xml'];
      if (!allowed.includes(file.type)) { setStatus('Unsupported file. Upload PNG, JPG or SVG.', true); upload.value = ''; return; }
      if (file.size > 1.5 * 1024 * 1024) { setStatus('Preview artwork is larger than 1.5 MB. Upload a smaller preview file; Gifty can collect original production artwork with the exact quote.', true); upload.value = ''; return; }
      const reader = new FileReader();
      reader.onload = () => {
        if (!artworkDataType(reader.result)) {
          setStatus('This artwork could not be validated safely. Export a clean PNG, JPG or SVG without external or active content.', true);
          upload.value = '';
          return;
        }
        if (file.type === 'image/svg+xml') {
          try {
            const svgText = atob(String(reader.result).split(',')[1] || '');
            if (/<script|<foreignObject|\son\w+\s*=|(?:href|src)\s*=\s*["'](?:https?:|data:text\/html)/i.test(svgText)) {
              setStatus('This SVG contains active or externally loaded content. Export a clean SVG or PNG for a safe preview.', true);
              upload.value = '';
              return;
            }
          } catch (_) {
            setStatus('This SVG could not be validated safely. Export a clean SVG or PNG.', true);
            upload.value = '';
            return;
          }
        }
        const image = new Image();
        image.onload = () => {
          const geometry = artworkGeometry(image.naturalWidth, image.naturalHeight, area, 42);
          if (!geometry) { setStatus('The image dimensions cannot be used safely. Upload a smaller preview image.', true); return; }
          ensureDesignId();
          const low = file.type !== 'image/svg+xml' && (image.naturalWidth < 1000 || image.naturalHeight < 1000);
          state.artworkName = file.name;
          state.artworkQuality = file.type === 'image/svg+xml' ? 'SVG artwork · production review required' : `${image.naturalWidth} × ${image.naturalHeight}px${low ? ' · Low resolution warning' : ' · Good preview resolution'}`;
          const item = { id: makeId('art'), type: 'image', name: file.name, data: reader.result, ...geometry, x: area.x + area.width / 2, y: area.y + area.height / 2, rotation: 0, opacity: 100, filter: 'original' };
          artworkData.set(item.id, item.data);
          state.objects.push(item); state.selectedId = item.id;
          render(); snapshot();
          setStatus(low ? 'Low-resolution artwork detected. Safe physical print size cannot be confirmed until Gifty configures the production area.' : 'Artwork added. Drag it to adjust placement.', low);
          pushEvent('customizer_artwork_added', { item_name: config.productTitle, file_type: file.type, low_resolution: low });
        };
        image.onerror = () => setStatus('The artwork could not be read. Try another file.', true);
        image.src = reader.result;
      };
      reader.onerror = () => setStatus('The artwork could not be read. Try another file.', true);
      reader.readAsDataURL(file);
    });

    $('[data-gxc-add-text]').addEventListener('click', () => {
      const text = textInput.value.trim();
      if (!text) { setStatus('Enter a short message before adding text.', true); return; }
      ensureDesignId();
      const item = { id: makeId('text'), type: 'text', text, x: area.x + area.width / 2, y: area.y + area.height / 2, size: 34, rotation: 0, opacity: 100, filter: 'original', fontFamily: 'Arial, sans-serif', color: '#0d243b', bold: true, italic: false, align: 'center', letterSpacing: 0 };
      state.objects.push(item); state.selectedId = item.id; textInput.value = '';
      render(); snapshot(); pushEvent('customizer_text_added', { item_name: config.productTitle });
    });

    objectsLayer.addEventListener('pointerdown', (event) => {
      if (event.isPrimary === false || event.button !== 0) return;
      const el = event.target.closest('[data-gxc-object]');
      if (!el) return;
      cancelActiveDrag?.();
      state.selectedId = el.dataset.gxcObject;
      const item = selected();
      const rect = stage.getBoundingClientRect();
      if (!item || !rect.width || !rect.height) return;
      const start = { x: event.clientX, y: event.clientY, itemX: item.x, itemY: item.y };
      stage.setPointerCapture?.(event.pointerId);
      render();
      const move = (moveEvent) => {
        if (moveEvent.pointerId !== event.pointerId) return;
        item.x = Math.max(0, Math.min(100, start.itemX + ((moveEvent.clientX - start.x) / rect.width) * 100));
        item.y = Math.max(0, Math.min(100, start.itemY + ((moveEvent.clientY - start.y) / rect.height) * 100));
        const centerX = area.x + area.width / 2;
        const centerY = area.y + area.height / 2;
        const snapX = Math.abs(item.x - centerX) < 1.8;
        const snapY = Math.abs(item.y - centerY) < 1.8;
        if (snapX) item.x = centerX;
        if (snapY) item.y = centerY;
        stage.classList.toggle('is-snapping-x', snapX);
        stage.classList.toggle('is-snapping-y', snapY);
        render();
      };
      const finish = (commit = true) => {
        stage.classList.remove('is-snapping-x', 'is-snapping-y');
        window.removeEventListener('pointermove', move);
        window.removeEventListener('pointerup', up);
        window.removeEventListener('pointercancel', cancel);
        if (stage.hasPointerCapture?.(event.pointerId)) stage.releasePointerCapture(event.pointerId);
        cancelActiveDrag = null;
        if (commit) snapshot();
      };
      const up = (endEvent) => { if (endEvent.pointerId === event.pointerId) finish(true); };
      const rollback = () => { item.x = start.itemX; item.y = start.itemY; render(); finish(false); };
      const cancel = (endEvent) => { if (endEvent.pointerId === event.pointerId) rollback(); };
      cancelActiveDrag = rollback;
      window.addEventListener('pointermove', move);
      window.addEventListener('pointerup', up);
      window.addEventListener('pointercancel', cancel);
    });
    objectsLayer.addEventListener('click', (event) => {
      const el = event.target.closest('[data-gxc-object]');
      if (el) { state.selectedId = el.dataset.gxcObject; render(); }
    });
    objectsLayer.addEventListener('keydown', (event) => {
      const el = event.target.closest('[data-gxc-object]');
      if (!el) return;
      state.selectedId = el.dataset.gxcObject;
      const item = selected();
      if (!item) return;
      if (event.key === 'Delete' || event.key === 'Backspace') {
        event.preventDefault();
        state.objects = state.objects.filter((candidate) => candidate.id !== item.id);
        state.selectedId = state.objects.at(-1)?.id || '';
        if (!state.objects.some((candidate) => candidate.type === 'image')) {
          state.artworkName = '';
          state.artworkQuality = 'No artwork uploaded';
        }
        render(); snapshot();
        return;
      }
      const delta = event.shiftKey ? 4 : 1;
      if (event.key === 'ArrowLeft') item.x -= delta;
      else if (event.key === 'ArrowRight') item.x += delta;
      else if (event.key === 'ArrowUp') item.y -= delta;
      else if (event.key === 'ArrowDown') item.y += delta;
      else return;
      event.preventDefault();
      item.x = Math.max(0, Math.min(100, item.x));
      item.y = Math.max(0, Math.min(100, item.y));
      render(); snapshot();
      objectsLayer.querySelector(`[data-gxc-object="${CSS.escape(item.id)}"]`)?.focus();
    });

    const bindRange = (control, key) => {
      control.addEventListener('input', () => { const item = selected(); if (!item) return; item[key] = Number(control.value); render(); });
      control.addEventListener('change', () => { if (selected()) snapshot(); });
    };
    bindRange(sizeControl, 'size'); bindRange(rotateControl, 'rotation'); bindRange(opacityControl, 'opacity');
    filterControl.addEventListener('change', () => { const item = selected(); if (!item) return; item.filter = filterControl.value; render(); snapshot(); });
    editTextControl?.addEventListener('input', () => {
      const item = selected();
      if (!item || item.type !== 'text') return;
      item.text = editTextControl.value.slice(0, 80);
      render();
    });
    editTextControl?.addEventListener('change', () => { if (selected()?.type === 'text') snapshot(); });
    [[layerBackwardButton, -1], [layerForwardButton, 1]].forEach(([button, direction]) => {
      button?.addEventListener('click', () => {
        if (!reorderLayer(state.objects, state.selectedId, direction)) return;
        render(); snapshot(); setStatus(config.layerUpdated);
      });
    });
    fontControl.addEventListener('change', () => { const item = selected(); if (!item || item.type !== 'text') return; item.fontFamily = fontControl.value; render(); snapshot(); });
    colorControl.addEventListener('input', () => { const item = selected(); if (!item || item.type !== 'text') return; item.color = colorControl.value; render(); });
    colorControl.addEventListener('change', () => { if (selected()?.type === 'text') snapshot(); });
    letterSpacingControl.addEventListener('input', () => { const item = selected(); if (!item || item.type !== 'text') return; item.letterSpacing = Number(letterSpacingControl.value); render(); });
    letterSpacingControl.addEventListener('change', () => { if (selected()?.type === 'text') snapshot(); });
    boldButton.addEventListener('click', () => { const item = selected(); if (!item || item.type !== 'text') return; item.bold = item.bold === false; render(); snapshot(); });
    italicButton.addEventListener('click', () => { const item = selected(); if (!item || item.type !== 'text') return; item.italic = !item.italic; render(); snapshot(); });
    alignButtons.forEach((button) => button.addEventListener('click', () => { const item = selected(); if (!item || item.type !== 'text') return; item.align = button.dataset.gxcAlign; render(); snapshot(); }));
    centerButton.addEventListener('click', () => { const item = selected(); if (!item) return; item.x = area.x + area.width / 2; item.y = area.y + area.height / 2; render(); snapshot(); });
    const smartFit = (item, compact = false) => {
      item.x = area.x + area.width / 2;
      item.y = area.y + area.height / 2;
      item.rotation = 0;
      if (item.type === 'image') {
        const widthFromHeight = area.height * Math.max(.0001, Number(item.aspect || 1));
        item.size = Math.min(area.width, widthFromHeight) * (compact ? .58 : .76);
      } else {
        item.size = compact ? 26 : 32;
        item.align = 'center';
        item.letterSpacing = Math.min(2, Number(item.letterSpacing || 0));
      }
    };
    fitButton.addEventListener('click', () => { const item = selected(); if (!item) return; smartFit(item, false); render(); snapshot(); });
    smartArrangeButton?.addEventListener('click', () => {
      const item = selected();
      if (!item) return;
      smartFit(item, state.objects.length > 1);
      if (item.type === 'image' && item.filter === 'original' && /white/i.test(item.name || '')) item.filter = 'white';
      render(); snapshot();
      setStatus('Smart arrangement applied inside the preview boundary. Review the visual and send it for exact production proofing.');
      pushEvent('customizer_smart_arrange', { item_name: config.productTitle, object_type: item.type });
    });
    artworkCheckButton?.addEventListener('click', () => {
      if (!state.objects.length) { setStatus('Add artwork or text before running the artwork check.', true); return; }
      const outsideCount = state.objects.filter(isOutside).length;
      const lowResolution = /low resolution/i.test(state.artworkQuality);
      const findings = [];
      findings.push(outsideCount ? `${outsideCount} element${outsideCount === 1 ? '' : 's'} extend outside the preview boundary` : 'all elements fit inside the preview boundary');
      if (lowResolution) findings.push('the uploaded bitmap may be too small for the intended physical print size');
      else if (state.artworkName) findings.push('preview resolution is acceptable for on-screen review');
      findings.push(config.mode === 'configured' ? 'this product has a configured placement profile' : 'print area, MOQ and branding method still require manual confirmation');
      setStatus(`Artwork check: ${findings.join('; ')}. This check supports layout review and does not replace a print-ready proof.`, outsideCount > 0 || lowResolution);
      pushEvent('customizer_artwork_check', { item_name: config.productTitle, outside_count: outsideCount, low_resolution: lowResolution });
    });
    deleteButton.addEventListener('click', () => {
      if (!selected()) return;
      state.objects = state.objects.filter((item) => item.id !== state.selectedId);
      state.selectedId = state.objects.at(-1)?.id || '';
      if (!state.objects.some((item) => item.type === 'image')) {
        state.artworkName = '';
        state.artworkQuality = 'No artwork uploaded';
      }
      render(); snapshot();
    });
    duplicateButton.addEventListener('click', () => { const item = selected(); if (!item) return; const copy = { ...item, id: makeId(item.type), x: Math.min(100, item.x + 5), y: Math.min(100, item.y + 5) }; if (copy.type === 'image' && copy.data) artworkData.set(copy.id, copy.data); state.objects.push(copy); state.selectedId = copy.id; render(); snapshot(); });
    undoButton.addEventListener('click', () => { if (historyIndex <= 0) return; historyIndex -= 1; restore(history[historyIndex]); });
    redoButton.addEventListener('click', () => { if (historyIndex >= history.length - 1) return; historyIndex += 1; restore(history[historyIndex]); });
    resetButton.addEventListener('click', () => {
      if (!state.objects.length || !window.confirm('Reset this preview and remove all added artwork and text?')) return;
      state.objects = []; state.selectedId = ''; state.artworkName = ''; state.artworkQuality = 'No artwork uploaded';
      render(); snapshot(); setStatus('Design reset. Your product and original artwork files were not changed.');
    });
    zoomControl.addEventListener('input', () => stage.style.setProperty('--gxc-zoom', String(Number(zoomControl.value) / 100)));
    fullscreenButton.addEventListener('click', () => {
      const active = backdrop.classList.toggle('is-fullscreen');
      fullscreenButton.setAttribute('aria-pressed', String(active));
      fullscreenButton.textContent = active ? 'Exit full screen' : 'Full screen';
    });

    saveButton.addEventListener('click', () => {
      if (!state.objects.length) { setStatus('Add a logo or text before saving.', true); return; }
      ensureDesignId();
      try { localStorage.setItem(storageKey, JSON.stringify({ ...stateForStorage(), savedAt: new Date().toISOString() })); setStatus(`Saved on this device as ${state.designId}.`); pushEvent('customizer_design_saved', { item_name: config.productTitle, design_id: state.designId }); }
      catch (_) { setStatus('This browser could not save the design locally. Request a quote to preserve the project details.', true); }
    });

    shareButton.addEventListener('click', async () => {
      if (!state.objects.length) return;
      ensureDesignId(); autoSave();
      const shareData = { title: `Gifty design ${state.designId}`, text: `Review my Gifty product mockup for ${config.productTitle}. Design ID: ${state.designId}`, url: config.productUrl };
      try {
        if (navigator.share) await navigator.share(shareData);
        else { await navigator.clipboard.writeText(`${shareData.text} ${new URL(config.productUrl, window.location.origin)}`); setStatus('Project reference copied. The saved mockup stays on this device; send the exact quote request to transfer production details.'); }
        pushEvent('customizer_design_shared', { item_name: config.productTitle, design_id: state.designId });
      } catch (error) { if (error?.name !== 'AbortError') setStatus('Sharing is unavailable in this browser. Save the design and send it with the quote form.', true); }
    });

    const summary = () => state.objects.length ? state.objects.map((item) => `${item.type === 'text' ? `Text: ${item.text}` : `Artwork: ${item.name}`} · x ${Math.round(item.x)}% · y ${Math.round(item.y)}% · size ${Math.round(item.size)}% · rotate ${Math.round(item.rotation)}°${item.filter && item.filter !== 'original' ? ` · ${item.filter}` : ''}`).join(' | ') : 'Gifty design help requested — no customer-built preview yet';
    const designManifest = () => JSON.stringify({
      version: 12,
      product: config.productHandle,
      designId: state.designId,
      objects: state.objects.map(({ data, ...item }) => item),
      serviceMode: state.serviceMode || 'self',
      proofRequested: !!proofControl?.checked,
      comments: String(commentsControl?.value || '').slice(0, 600),
      previewOnly: true
    });
    const addHidden = (form, name, value) => {
      let input = form.querySelector(`input[data-gxc-field="${name}"]`);
      if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.dataset.gxcField = name; input.name = name; form.append(input); }
      const text = String(value ?? '');
      input.value = text;
      input.setAttribute('value', text);
    };

    quoteButton.addEventListener('click', () => {
      if (!quantityControl.checkValidity() || !Number.isSafeInteger(Number(quantityControl.value)) || Number(quantityControl.value) < 1) {
        activateStep(backdrop.querySelector('[data-gxc-step-button="order"]'));
        quantityControl.focus();
        setStatus(config.invalidQuantity, true);
        return;
      }
      ensureDesignId();
      const quotePanel = document.querySelector('[data-gifty-quote]');
      const quoteForm = quotePanel?.querySelector('form');
      if (!quoteForm) { setStatus('Quote form is unavailable on this page. Please use the main Request a Quote page.', true); return; }
      addHidden(quoteForm, 'contact[Design ID]', state.designId);
      addHidden(quoteForm, 'contact[Design summary]', summary());
      addHidden(quoteForm, 'contact[Design manifest]', designManifest());
      addHidden(quoteForm, 'contact[Artwork filename]', state.artworkName || 'No file uploaded');
      addHidden(quoteForm, 'contact[Artwork quality]', state.artworkQuality);
      addHidden(quoteForm, 'contact[Production status]', config.mode === 'configured' ? 'Profile configured — artwork approval required' : 'Manual production review required');
      addHidden(quoteForm, 'contact[Gift brief]', state.giftBrief || 'Not provided');
      addHidden(quoteForm, 'contact[Design service]', state.serviceMode === 'assisted' ? 'Please have Gifty create the first layout' : 'Customer created a browser preview');
      addHidden(quoteForm, 'contact[Digital proof]', proofControl?.checked ? 'Requested before production' : 'Discuss proof preference');
      addHidden(quoteForm, 'contact[Customizer notes]', String(commentsControl?.value || '').slice(0, 600) || 'None provided');
      const notes = quoteForm.querySelector('textarea[name="contact[body]"]');
      if (notes && !notes.value.trim()) notes.value = [state.giftBrief, commentsControl?.value].filter(Boolean).join('\n\n');
      const q = quoteForm.querySelector('[data-gqf-quantity]');
      if (q) { q.value = quantityControl.value; q.dataset.customerEdited = 'true'; }
      const m = quoteForm.querySelector('select[name="contact[Branding preference]"]'); if (m) m.value = methodControl.value;
      quotePanel.open = true; autoSave(); close(); quotePanel.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      pushEvent('customizer_request_quote', { item_name: config.productTitle, design_id: state.designId, requested_quantity: Number(quantityControl.value) });
    });

    cartButton.addEventListener('click', () => {
      if (config.mode !== 'configured') {
        setStatus('Direct cart purchase is available only after this product has an approved production profile. Request an exact quote instead.', true);
        return;
      }
      if (!quantityControl.checkValidity() || !Number.isSafeInteger(Number(quantityControl.value)) || Number(quantityControl.value) < 1) {
        activateStep(backdrop.querySelector('[data-gxc-step-button="order"]'));
        quantityControl.focus();
        setStatus(config.invalidQuantity, true);
        return;
      }
      ensureDesignId();
      const productForms = [...document.querySelectorAll('product-form form[action*="/cart/add"], form[data-type*="add-to-cart-form"][action*="/cart/add"], form[action*="/cart/add"]')];
      const productForm = productForms.find((form) => String(form.querySelector('input[name="id"]')?.value || '') === String(config.variantId))
        || productForms.find((form) => form.closest('product-info') && form.querySelector('button[name="add"],button[type="submit"]'));
      if (!productForm) { setStatus('The product form is unavailable. Request a quote instead.', true); return; }
      addHidden(productForm, 'properties[_Gifty Design ID]', state.designId);
      addHidden(productForm, 'properties[Customization]', 'Artwork approval required before production');
      addHidden(productForm, 'properties[Branding method]', methodControl.value);
      addHidden(productForm, 'properties[Design summary]', summary());
      addHidden(productForm, 'properties[Design manifest]', designManifest());
      addHidden(productForm, 'properties[Artwork filename]', state.artworkName || 'No file uploaded');
      addHidden(productForm, 'properties[Artwork quality]', state.artworkQuality);
      addHidden(productForm, 'properties[Gift brief]', state.giftBrief || 'Not provided');
      addHidden(productForm, 'properties[Digital proof]', proofControl?.checked ? 'Requested before production' : 'Discuss proof preference');
      if (upload.files?.length && productForm.id) {
        upload.name = 'properties[Artwork file]';
        upload.setAttribute('form', productForm.id);
        productForm.enctype = 'multipart/form-data';
      }
      // Dawn associates its quantity input using the form attribute.
      const quantity = productForm.elements.namedItem('quantity');
      if (quantity) quantity.value = quantityControl.value;
      autoSave(); close();
      pushEvent('customizer_add_to_cart', { item_name: config.productTitle, design_id: state.designId, quantity: Number(quantityControl.value) });
      productForm.querySelector('button[name="add"],button[type="submit"]')?.click();
    });

    // Product information columns can establish a containing block for fixed
    // descendants. Mount the dialog at document level so it is genuinely
    // viewport-sized on every Shopify product layout.
    backdrop.classList.add('gxc');
    document.body.append(backdrop);

    try {
      const saved = JSON.parse(localStorage.getItem(storageKey) || 'null');
      const restored = saved?.objects?.length ? stateFromStorage(saved) : null;
      if (restored?.objects?.length) {
        state = { serviceMode: 'self', ...restored, giftBrief: transferredBrief || saved.giftBrief || '' };
        const activeServiceButton = serviceModeButtons.find((button) => button.dataset.gxcServiceMode === state.serviceMode) || serviceModeButtons[0];
        serviceModeButtons.forEach((button) => button.classList.toggle('is-active', button === activeServiceButton));
        if (assistedNote) assistedNote.hidden = state.serviceMode !== 'assisted';
        state.objects.forEach((item) => { if (item.type === 'image' && item.data) artworkData.set(item.id, item.data); });
        history = [stateForHistory(state)]; historyIndex = 0; render(); setStatus(`Restored local draft ${state.designId}.`);
      }
      else { render(); if (transferredBrief) setStatus('Your Gift Concierge brief was transferred. Add artwork or text to continue.'); }
    } catch (_) { render(); }
    try {
      const transfer = JSON.parse(localStorage.getItem('gifty-ai-transfer') || 'null');
      const age = Date.now() - Number(transfer?.savedAt || 0);
      const fresh = transfer?.data && age >= 0 && age < 60 * 60 * 1000;
      const alreadyAdded = state.objects.some((item) => item.type === 'image' && item.data === transfer?.data);
      if (fresh && !alreadyAdded && artworkDataType(transfer.data)) {
        const transferredImage = new Image();
        transferredImage.onload = () => {
          if (state.objects.some((item) => item.type === 'image' && item.data === transfer.data)) return;
          const geometry = artworkGeometry(transferredImage.naturalWidth, transferredImage.naturalHeight, area, 38);
          if (!geometry) { setStatus('The transferred image is too large. Upload a smaller preview in the studio.', true); return; }
          ensureDesignId();
          const item = { id: makeId('art'), type: 'image', name: String(transfer.name || 'Uploaded logo').slice(0, 180), data: transfer.data, ...geometry, x: area.x + area.width / 2, y: area.y + area.height / 2, rotation: 0, opacity: 100, filter: 'original' };
          artworkData.set(item.id, item.data);
          state.objects.push(item); state.selectedId = item.id; state.artworkName = item.name; state.artworkQuality = 'Logo transferred from Gifty assistant · production review required';
          render(); snapshot(); setStatus('Your uploaded logo was transferred at its original proportions. Position it and send the design for exact production review.');
          pushEvent('customizer_ai_artwork_transferred', { item_name: config.productTitle, file_type: artworkDataType(transfer.data) });
        };
        transferredImage.onerror = () => setStatus('The transferred logo could not be read. Please upload it in the studio.', true);
        transferredImage.src = transfer.data;
      }
    } catch (_) { /* Transfer is optional and remains local to the browser. */ }
    if (urlParams.get('open_customizer') === '1') window.setTimeout(open, 650);
  });
})();
